"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CsBsKvs = void 0;
var axios_1 = __importDefault(require("axios"));
var index_1 = require("./index");
/**
 * CsBsKvs
 *
 * @class CsBsKvs
 * @implements {ICsBsKvs}
 */
var CsBsKvs = /** @class */ (function () {
    /**
     * Creates an instance of CsBsKvs.
     * @memberof CsBsKvs
     */
    function CsBsKvs() {
        // ローカルにログを取るかどうか
        this.locallog = false;
        // タイムアウト設定（単位ms）
        this.timeout = 10000;
        if (index_1.Location.getUrlVars()['locallog'] == 'true') {
            this.locallog = true;
        }
        if (this.locallog && index_1.CsBsKvsStorage.storageAvailable()) {
            this.csBsKvsStorage = new index_1.CsBsKvsStorage('csbskvslog');
        }
    }
    /**
     * GET:取得
     *
     * @param {CsBsKVSData} data
     * @return {*}  {Promise<CsBsKVSData>}
     * @memberof CsBsKvs
     */
    CsBsKvs.prototype.get = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var method, apiPath;
            var _this = this;
            return __generator(this, function (_a) {
                method = 'get';
                apiPath = CsBsKvs.path + '?method=' + method;
                console.log(data);
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        axios_1.default
                            .create(_this.getParams())
                            .post(apiPath, data)
                            .then(function (response) {
                            // 正常
                            resolve(response.data);
                        })
                            .catch(function (error) {
                            // 異常
                            reject(_this.createError(error));
                        });
                    })];
            });
        });
    };
    /**
     * POST:登録
     *
     * @param {CsBsKVSData} data
     * @return {*}  {Promise<void>}
     * @memberof CsBsKvs
     */
    CsBsKvs.prototype.post = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var method, apiPath;
            var _this = this;
            return __generator(this, function (_a) {
                method = 'post';
                apiPath = CsBsKvs.path + '?method=' + method;
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        axios_1.default
                            .create(_this.getParams())
                            .post(apiPath, data)
                            .then(function (response) {
                            // 正常
                            if (_this.csBsKvsStorage) {
                                index_1.CsBsKvsStorageUtil.pushData({
                                    storage: _this.csBsKvsStorage,
                                    data: data,
                                    groupId: _this.csBsKvsStorage.getNewGroupId(),
                                    apiRegist: true,
                                    hasError: false,
                                });
                            }
                            // 正常
                            resolve(response.data);
                        })
                            .catch(function (error) {
                            // 異常
                            if (_this.csBsKvsStorage) {
                                index_1.CsBsKvsStorageUtil.pushData({
                                    storage: _this.csBsKvsStorage,
                                    data: data,
                                    groupId: _this.csBsKvsStorage.getNewGroupId(),
                                    apiRegist: true,
                                    hasError: true,
                                });
                            }
                            reject(_this.createError(error));
                        });
                    })];
            });
        });
    };
    /**
     * PUT:更新
     *
     * @param {CsBsKVSData} data
     * @return {*}  {Promise<void>}
     * @memberof CsBsKvs
     */
    CsBsKvs.prototype.put = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var method, apiPath;
            var _this = this;
            return __generator(this, function (_a) {
                method = 'put';
                apiPath = CsBsKvs.path + '?method=' + method;
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        axios_1.default
                            .create(_this.getParams())
                            .post(apiPath, data)
                            .then(function (response) {
                            // 正常
                            if (_this.csBsKvsStorage) {
                                index_1.CsBsKvsStorageUtil.pushData({
                                    storage: _this.csBsKvsStorage,
                                    data: data,
                                    groupId: _this.csBsKvsStorage.getNewGroupId(),
                                    apiRegist: true,
                                    hasError: false,
                                });
                            }
                            // 正常
                            resolve(response.data);
                        })
                            .catch(function (error) {
                            // 異常
                            if (_this.csBsKvsStorage) {
                                index_1.CsBsKvsStorageUtil.pushData({
                                    storage: _this.csBsKvsStorage,
                                    data: data,
                                    groupId: _this.csBsKvsStorage.getNewGroupId(),
                                    apiRegist: true,
                                    hasError: true,
                                });
                            }
                            reject(_this.createError(error));
                        });
                    })];
            });
        });
    };
    /**
     * DELETE:削除
     *
     * @param {CsBsKVSData} data
     * @return {*}  {Promise<void>}
     * @memberof CsBsKvs
     */
    CsBsKvs.prototype.delete = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var method, apiPath;
            var _this = this;
            return __generator(this, function (_a) {
                method = 'delete';
                apiPath = CsBsKvs.path + '?method=' + method;
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        axios_1.default
                            .create(_this.getParams())
                            .post(apiPath, data)
                            .then(function (response) {
                            // 正常
                            resolve(response.data);
                        })
                            .catch(function (error) {
                            // 異常
                            reject(_this.createError(error));
                        });
                    })];
            });
        });
    };
    /**
     * エラーを作成
     *
     * @private
     * @param {AxiosError} error
     * @return {*}  {Error}
     * @memberof CsBsKvs
     */
    CsBsKvs.prototype.createError = function (error) {
        if (error.code && error.code == 'ECONNABORTED') {
            // タイムアウト発生
            error.message = 'Error:タイムアウトが発生しました。';
            return error;
            // return new Error('Error:タイムアウトが発生しました。')
        }
        else if (error.response && error.response.status) {
            // response.status が 200意外の場合に発生
            error.message =
                'Error:' +
                    CsBsKvs.getHTTPStatusNumber(error.response) +
                    ':' +
                    CsBsKvs.getErrorMessage(error.response).join(',');
            return error;
            // return new Error(
            //   'Error:' +
            //     CsBsKvs.getHTTPStatusNumber(error.response) +
            //     ':' +
            //     CsBsKvs.getErrorMessage(error.response).join(','),
            // )
        }
        else if (!error.response) {
            // レスポンスがない
            error.message = 'Error:通信エラーが発生しました。';
            return error;
            // return new Error('Error:通信エラーが発生しました。')
        }
        else {
            // その他のエラー：不明なエラー
            error.message = 'Error:不明なエラーが発生しました。';
            return error;
            // return new Error('Error:不明なエラーが発生しました。')
        }
    };
    /**
     * HTTP status番号を返します
     */
    CsBsKvs.getHTTPStatusNumber = function (response) {
        var result = '不明なエラー';
        if (response) {
            switch (response.status) {
                case 200:
                // 200 正常 リクエストは成功しました
                case 400:
                // 400 異常 リクエストが不正です（必須入力エラーが発生しました）
                case 401:
                // 401 異常 アプリID/会員番号が不正です
                case 404:
                // 404 異常 要求されたリソースは存在しません
                case 415:
                // 415 異常 JSON 形式が不正です
                case 500:
                // 500 異常 予期せぬエラーが発生しました
                case 500:
                // 503 異常 サーバがメンテナンス中です
                default:
                    if (response.status) {
                        result = "" + response.status;
                    }
                    break;
            }
        }
        return result;
    };
    /**
     * レスポンスデータからエラーメッセージを返します。
     */
    CsBsKvs.getErrorMessage = function (response) {
        var statusNumber = CsBsKvs.getHTTPStatusNumber(response);
        var errorMessages = [];
        if (statusNumber == '200') {
            // do nothing
        }
        else if (response) {
            // レスポンスあり
            try {
                // エラー文作成
                //
                // エラーレスポンス例：
                // {
                //   "errors": [
                //     {
                //     "resource": "(データ名称)",
                //     "error_code": "WE03-0111-C011",
                //     "error_message": "アプリIDが設定されていません"
                //     }
                //   ]
                // }
                // errors
                response.data.errors.forEach(function (error) {
                    // console.log(error.resource)
                    // console.log(error.error_code)
                    // console.log(error.error_message)
                    errorMessages.push(error.error_code + ":" + error.error_message + "(" + error.resource + ")");
                });
            }
            catch (error) {
                // エラーメッセージパース不可
                errorMessages.push("\u4E0D\u660E\u306A\u30A8\u30E9\u30FC");
            }
        }
        else {
            // レスポンスなし
            errorMessages.push("\u901A\u4FE1\u30A8\u30E9\u30FC");
        }
        return errorMessages;
    };
    /**
     * 送信で共通に必要なパラメータ情報を返します
     *
     * @return {*}  {*}
     * @memberof CsBsKvs
     */
    CsBsKvs.prototype.getParams = function () {
        var param = {
            withCredentials: true,
            timeout: this.timeout,
            headers: {},
        };
        if (this.sessionId) {
            param.headers = {
                'X-LOCAL-APP-HTTPS-KEY': this.sessionId,
            };
        }
        return param;
    };
    return CsBsKvs;
}());
exports.CsBsKvs = CsBsKvs;
//# sourceMappingURL=CsBsKvs.js.map